import { createContentfulApi } from '@asicsdigital/oneasics-blocks';

import { contentfulAPIConfig } from '../utils/configs';

const contentfulApi = createContentfulApi(contentfulAPIConfig);

export { contentfulApi };
